import React from 'react';
import { DefaultAvatar } from '../../common/DefaultAvatar';
import UserDoctorRegularIcon from '../../icons/user-doctor-regular';

const DocAvatarUi = ({
    pic,
    name,
    isSelected = false,
    picType = 'large',
}: {
    pic?: string;
    name?: string;
    isSelected?: boolean;
    picType?: 'small' | 'large';
}): JSX.Element => {
    if (pic) {
        return (
            <img
                src={pic}
                className={`${
                    picType === 'large' ? 'dr-w-24 dr-h-24' : 'dr-w-16 dr-h-16'
                } dr-rounded-circle`}
                alt=""
            />
        );
    }
    if (name) {
        return <DefaultAvatar name={name} version="small" />;
    }
    return (
        <UserDoctorRegularIcon
            className={`dr-w-14 dr-h-14 ${
                isSelected ? 'dr-text-darwin-primary-primary' : 'dr-text-darwin-neutral-800'
            }`}
        />
    );
};

export default DocAvatarUi;
